import classnames from 'classnames'
import { FC, CSSProperties, Ref, ReactNode } from 'react'

import styles from './Flex.module.scss'

interface FlexProps extends CSSProperties {
  className?: string
  innerRef?: Ref<HTMLDivElement>
  children?: ReactNode
}

const Flex: FC<FlexProps> = ({ className, children, innerRef, ...props }) => (
  <div ref={innerRef} className={classnames(className, styles.base)} style={{ ...props }}>
    {children}
  </div>
)

export default Flex
